// Sample card from Airbnb
import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import AuthService from "../../../../services/auth.service";
import swal from 'sweetalert';
import classes from "./styles.module.css"; 

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
} from '@chakra-ui/react';

function FormKontakPribadiPeserta() {
    const navigate = useNavigate();
    const [nomorPonselPeserta, setNomorPonselPeserta] = useState('');
    const [provinsi, setProvinsi] = useState('');
    const [kota, setKota] = useState('');
    const [kecamatan, setKecamatan] = useState('');
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    const currentUser = AuthService.getCurrentUser();

    useEffect(() => {
        getPesertaById();
        
    }, []);
    
    const getPesertaById = async() => {
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNomorPonselPeserta(data.nomorPonselPeserta);
        setProvinsi(data.provinsi);
        setKota(data.kota);
        setKecamatan(data.kecamatan);
    };

    const updateKontakPribadi = async (e) => {
        e.preventDefault();
        swal("Apakah Anda yakin ingin mengubah kontak pribadi?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`v1/kontak/peserta/${id}`, {
                    nomorPonselPeserta: nomorPonselPeserta,
                    provinsi: provinsi,
                    kota: kota,
                    kecamatan: kecamatan
                })
                swal({
                    title: "Kontak pribadi berhasil tersimpan!",
                    icon: "success",
                    button: "OK",
                }).then(() => {
                    navigate(`/peserta/profile/kontak/${id}`)
                })
                .catch((error) => {
                    console.log(error);
                    setValidation(error.response.data);
                })
            }
            return false;
        });
        
    };

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Kontak Pribadi
                    </Heading>

                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }

                    <Form onSubmit={updateKontakPribadi}>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='emailUser'>Email</FormLabel>
                        <Input 
                            isDisabled 
                            id='emailUser'
                            value={currentUser.emailUser}
                            ></Input>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='nomorPonselPeserta'>Nomor ponsel</FormLabel>
                        <Input 
                        id='nomorPonselPeserta' 
                        placeholder='Masukkan nomor ponsel'
                        value={nomorPonselPeserta}
                        onChange={(e) => setNomorPonselPeserta(e.target.value)} />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='provinsi'>Provinsi</FormLabel>
                        <Input 
                        id='provinsi' 
                        placeholder='Masukkan provinsi'
                        value={provinsi}
                        onChange={(e) => setProvinsi(e.target.value)} />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kota'>Kota / Kabupaten</FormLabel>
                        <Input 
                        id='kota' 
                        placeholder='Masukkan kota/kabupaten'
                        value={kota}
                        onChange={(e) => setKota(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kecamatan'>Kecamatan</FormLabel>
                        <Input 
                        id='kecamatan' 
                        placeholder='Masukkan kecamatan' 
                        value={kecamatan}
                        onChange={(e) => setKecamatan(e.target.value)}/>
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                loadingText='Submitting'
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormKontakPribadiPeserta;